function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 8.27339,
  cy: 7.49519,
  r: 7.3072
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.53506 5.5507L8.51279 4.76179C8.64586 4.7232 8.77226 4.65525 8.8771 4.55041C9.20935 4.21816 9.20935 3.67993 8.87696 3.34754C8.54457 3.01515 8.00605 3.01458 7.67366 3.34697C7.34127 3.67936 7.34155 4.21816 7.67394 4.55055C7.79112 4.66773 7.93441 4.74122 8.08478 4.77583L8.10691 5.56375C8.2492 5.54403 8.39249 5.53892 8.53506 5.5507Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.2986 7.21861L11.7445 6.85061C11.7823 6.91885 11.8265 6.98481 11.8842 7.04255C12.2172 7.37551 12.7555 7.37537 13.0879 7.04298C13.4202 6.71073 13.4202 6.1725 13.0872 5.83954C12.7548 5.50715 12.2169 5.50715 11.8845 5.83954C11.7195 6.00453 11.6369 6.22016 11.6357 6.43651L10.194 6.80365C10.2445 6.93786 10.2794 7.07717 10.2986 7.21861Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6.9665 10.1356L7.53055 9.23673C7.40316 9.17516 7.28129 9.1004 7.16695 9.0096L6.60304 9.90888C6.31023 9.81724 5.97883 9.88335 5.74674 10.1154C5.4145 10.4477 5.41464 10.9855 5.74759 11.3185C6.07984 11.6507 6.61779 11.6507 6.9499 11.3186C7.27647 10.9929 7.28058 10.469 6.9665 10.1356Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M6.74146 6.43324L5.49717 5.81343C5.55391 5.54162 5.47773 5.24753 5.26706 5.03686C4.93467 4.70447 4.39658 4.70461 4.06434 5.03686C3.73166 5.36953 3.73152 5.90763 4.06391 6.24001C4.39602 6.57212 4.93482 6.57269 5.26749 6.24002C5.28139 6.22611 5.29118 6.21037 5.30367 6.19561L6.55179 6.81755C6.60059 6.68448 6.66287 6.55524 6.74146 6.43324Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.2104,
  cy: 13.4322,
  r: 5.9371,
  fill: "#F1F2F5"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4706 15.4087V14.4672H14.6419V11.4648L13.7449 11.9912L13.3075 11.1535L14.9755 10.1824H15.791V14.4672H16.8881V15.4087H13.4706Z",
  fill: "#23244D",
  fillOpacity: 0.5
});

var SvgChannels1Icon = function SvgChannels1Icon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChannels1Icon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/channels-1-icon.436f9a22.svg";
export { ForwardRef as ReactComponent };